<mat-card>
    <mat-card-header>
        <mat-card-title>{{ model.brand.name }} {{ model.name }}</mat-card-title>
        <mat-card-subtitle class="model-subtitle">{{ model.year}}</mat-card-subtitle>
    </mat-card-header>
    <mat-divider></mat-divider>
    <mat-card-content class="pt-2">
        <p>{{ model.description }}</p>
    </mat-card-content>
    <mat-card-footer class="p-3 model-footer">
        Prix moyen constaté : {{ model.price }} €
    </mat-card-footer>
</mat-card>